module.exports = __webpack_public_path__ + "img/plane.6fab8102.png";